import React, {useState, useEffect} from "react";

export default function InputSearch ({values, value, onChangeInput, onChangeSelect}: any) {

  const LABELFILTRO: any = {
    "documento": "Nº de documento",
    "nombres": "Ingresa los datos",
    "nroOperacion": "Nro. de operación",
  };

  const getInitialType = () => {
    const firstKey = Object.keys(values)[0];
    return LABELFILTRO[firstKey] || "Nº de documento";
  };

  const [type, setType] = useState(getInitialType());

  useEffect(() => {
    const firstKey = Object.keys(values)[0];
    const newType = LABELFILTRO[firstKey] || "Nº de documento";
    setType(newType);
  }, [values]);

  let onChangeSelectReturn = (e: any)=>{};

  const onChangeSelectIntercept = (event: any)=>{
    const val = event.target.value;
    setType(LABELFILTRO[val]);
    return onChangeSelectReturn(event);
  }
  
  onChangeSelectReturn = onChangeSelect;

  return(
  <div className="inputSearch">
    <select onChange={onChangeSelectIntercept}>
      {Object.keys(values).map((item, i) => 
        <option key={i} value={item}>{values[item]}</option>
      )}
    </select>
    <div className="workData__form__item input-field">
      <input
        type="text"
        autoComplete="off"
        maxLength={50}
        id="document"
        name="document"
        value={value}
        onChange={onChangeInput}
      />
      <label className={"activo"} htmlFor="document">
        {type}
      </label>
    </div>
  </div>
  )
};